// extracted by mini-css-extract-plugin
export default {"root":"Ny1bv","large":"hkWku","hoverable":"_1NrXV","medium":"_218PR","small":"_2-Rbe"};